import { Stack } from "@introist/react-foundation/v2";

import { ScheduleEditor } from "./modules/datasets/sync/ScheduleEditor";
import { useState } from "react";

export const Playground = () => {
  const [schedule, setSchedule] = useState({
    days: [1, 2, 3],
    hours: [0, 1, 2],
    timezone: "Asia/Tokyo"
  });

  return (
    <Stack vertical justifyContent="center" alignItems="center" style={{ minHeight: "100vh" }}>
      <ScheduleEditor schedule={schedule} onChange={setSchedule} title="Schedule" />
    </Stack>
  );
};
